import React, { useState, useCallback, useEffect } from 'react';
import './LookAtObject.css';
import RoundSlider from '../helpers/RoundSlider';
import { Globals } from '../../../misc/helpers';
import { isConstructorDeclaration } from 'typescript';

const LookAtObjectTutorial = (obj: any) => {
	var isHoldingKnob = false;
	var registeredEvents = false;
	var sliderImg: any = null;
	var knobToRotate: any = null;
	var currentRotation = 0;
	const [sliderValue, setSliderValue] = useState(50);

	useEffect(() => {
		if (!registeredEvents) {
			// $(window).on('mouseup', () => {
			// 	isHoldingKnob = false;
			// })
			registeredEvents = true;

		}
	}, [isHoldingKnob]);

	var clamp = (val: number, min: number, max: number) => {
		if (val < min) {
			val = min;
		}

		if (val > max) {
			val = max;
		}

		return val;
	};

	var onChangeValueKeyboard = (evt: any) => {
		knobToRotate = document.getElementById('knobToRotate');
		var currentPercent = parseInt(knobToRotate.style.transform.replace('rotate(','').replace('deg)',''));

		var marginRotation = evt.keyCode == 37 
			? 1
			: evt.keyCode == 39
				? -1
				: 0; 


		var newRotation = currentPercent + marginRotation;
		if(Math.abs(newRotation) >= 74) return;

		var rotatePercentage = 0.50 + (newRotation * -1*0.00676); //calculated perfcentage for Unity component;

		if (newRotation !== currentPercent) {
			obj.parameters.dispatch({
				type: 'playSequence',
				value: {
					sequenceName: 'LookAtObject',
					props: {
						sequenceProps: {
							percentage: rotatePercentage
						}
					},
					skipAnimations: Globals.skipAnimations
				}
			});
			currentRotation = newRotation;
		}

		$(knobToRotate).css({
			transform: 'rotate(' + newRotation + 'deg)'
		});
	};

	var onMouseMove = (evt: any) => {
		if (!isHoldingKnob) {
			return;
		}
		if (!sliderImg) {
			sliderImg = document.getElementById('sliderImg');
			knobToRotate = document.getElementById('knobToRotate');
		}

		if (!sliderImg) {
			console.error('can\'t find slider image');
			return;
		}

		if (!knobToRotate) {
			console.error('can\'t find knob image');
			return;
		}

		var mouseAbsolutePosition = { x: evt.pageX ?? evt.changedTouches[0].pageX, y: evt.pageY ?? evt.changedTouches[0].pageY};
		var mousePositionRelativeToSliderImage = {
			x: mouseAbsolutePosition.x - $(sliderImg).offset().left,
			y: mouseAbsolutePosition.y - $(sliderImg).offset().top
		};

		if (mousePositionRelativeToSliderImage.x < 0) {
			mousePositionRelativeToSliderImage.x = 0;
		}

		if (mousePositionRelativeToSliderImage.y < 0) {
			mousePositionRelativeToSliderImage.y = 0;
		}

		// var clickableHeightPercentageOfImage = 0.5;

		var matrix = $('.ui-container-root').css('transform');
		var scale = matrix.split('(')[1];
		scale = scale.split(')')[0];
		scale = scale.split(',')[0];
		var imgDimentions = {
			width: $(sliderImg).width() * parseFloat(scale), //account for main container scale
			height: $(sliderImg).height() * parseFloat(scale)
		}

		var clickedPercentage = {
			x: clamp(mousePositionRelativeToSliderImage.x / imgDimentions.width, 0, 1),
			y: clamp(mousePositionRelativeToSliderImage.y / imgDimentions.height, 0, 1)
		}


		// if(clickedPercentage.y < clickableHeightPercentageOfImage) {
		// 	return;
		// }

		var maxRotation = 74 * 2; //-74 = min rotation

		var newRotation = (((clickedPercentage.x * maxRotation) - 74) * -1);

		if (newRotation !== currentRotation) {
			obj.parameters.dispatch({
				type: 'playSequence',
				value: {
					sequenceName: 'LookAtObject',
					props: {
						sequenceProps: {
							percentage: clickedPercentage.x
						}
					},
					skipAnimations: Globals.skipAnimations
				}
			});
			currentRotation = newRotation;
		}

		$(knobToRotate).css({
			transform: 'rotate(' + newRotation + 'deg)'
		})
	}

	return (
		<div className="modal-disable-select ui-container">
			<div className="ui-inner-container look-at-object-container">
				<div style={{
					position: 'absolute',
					bottom: '60px'
				}}>
					<div style={{
						position: 'relative',
						width: '50%',
						left: '50%',
						transform: 'translate(-50%, 0)'
					}}>
						<img id="sliderImg" style={{
							// width: '50%'
						}} src="./assets/img/curved_slider.png" />
						<div id="knobToRotate" style={{
							position: 'absolute',
							bottom: '0',
							width: '100%',
							height: '100%',
							transform: 'rotate(0deg)'
						}}>
							<div style={{
								position: 'absolute',
								bottom: '1%',
								left: '50%',
								transform: 'translate(-50%, 0)',
								cursor: 'pointer'
							}}
							className="rs-handle"
							tabIndex={0}
							aria-label="Drag to move camera around bleeding site" 
							role="slider"
							onKeyDown={onChangeValueKeyboard}></div>
						</div>
					</div>

				</div>
				<div style={{
					width: '100%',
					height: '50%',
					position: 'absolute',
					bottom: '0'
				}}
					onMouseUp={() => isHoldingKnob = false}
					onMouseMove={onMouseMove}
					onMouseDown={() => isHoldingKnob = true}
					onTouchStart={() => isHoldingKnob = true}
					onTouchEnd={() => isHoldingKnob = false}
					onTouchCancel={() => isHoldingKnob = false}
					onTouchMove={onMouseMove}>

				</div>
			</div>
		</div>
	);
};

export default LookAtObjectTutorial;
